export default {
    'date-format': {
        en: {
            short: {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                timeZone: 'UTC',
            },
            long: {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                weekday: 'short',
                hour: 'numeric',
                minute: 'numeric',
                timeZone: 'UTC',
            },
            long_date: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
                timeZone: 'UTC',
            },
        },
    },

    'number-format': {
        en: {
            currency: {
                style: 'currency',
                currency: 'USD',
            },
            decimal: {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
            percent: {
                style: 'percent',
                useGrouping: false,
            },
        },
    },
};
